// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root___X1Zn","selected":"Chip_selected__vaLcc"};